const useScrollAnimate = () => {
  const setAnimate = () => {
    const work = document.querySelector('.work')
    if (!work) return

    const startPoint = document.querySelector('.header')?.getBoundingClientRect().height || 80
    if (window.scrollY > startPoint) {
      work.classList.add('is-animated')
    } else {
      work.classList.remove('is-animated')
    }
  }

  setAnimate()
  window.addEventListener('scroll', setAnimate)
}

document.addEventListener('DOMContentLoaded', () => {
  useScrollAnimate()
})